import { useSnackbar } from 'notistack'
import React from 'react'
import { useFreeServiseTimesQuery, useStartProtectionDays } from '../../../../api/timeTerms/hooks'
import { ActivationObject } from '../../../providers/ActivationObjectProvider/types'
import { Step3FormProps, Step3FormOptionsProps } from '../types'

const useStep3FormOptions = (form: Step3FormProps['form'], activationObject?: ActivationObject): Step3FormOptionsProps => {
    const handoverDate = form.watch('handoverDate')
    const {
        data: handoverTimes,
        isLoading: isHandoverTimesLoading,
        error: handoverTimesError,
    } = useFreeServiseTimesQuery(activationObject?.arrivalVehicle, activationObject?.synonym, handoverDate)

    // handle options loading error
    const { enqueueSnackbar } = useSnackbar()
    React.useEffect(() => {
        if (handoverTimesError) enqueueSnackbar(handoverTimesError.detail, { variant: 'error' })
    }, [enqueueSnackbar, handoverTimesError])

    const { data: startProtectionDays } = useStartProtectionDays(activationObject?.synonym, false)
    return {
        handoverTimes: handoverTimes?.days
            .filter((d) => d.isAvailable)
            .map((d) => {
                return {
                    value: d.intervalFrom,
                    label: `${d.intervalFrom}:00 - ${d.intervalTo}:00`,
                }
            }),
        isHandoverTimesLoading,
        startProtectionDays,
    }
}

export default useStep3FormOptions
